var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M15.7 14.3L11.4 10c2-2.8 1.4-6.7-1.4-8.7S3.3-.1 1.2 2.7s-1.4 6.7 1.4 8.7c2.2 1.6 5.1 1.6 7.3 0l4.3 4.3c.4.4 1.1.3 1.4-.1.4-.4.4-.9.1-1.3zm-12.4-5c-1.6-1.6-1.6-4.3 0-6s4.3-1.6 6 0 1.6 4.3 0 6c-.8.8-1.8 1.2-3 1.2-1.1 0-2.2-.4-3-1.2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Search.svg